import { StackHeaderProps, Header as RNHeader } from '@react-navigation/stack'
import { Box } from 'native-base'
import React from 'react'
import { ViewStyle } from 'react-native'

// Haven't been able to find a way to have the header that has a background colour and the contents inside a 600px container
// So creating a custom component that does this and forwards the props to the react-navigation Header
export const Header: React.FC<StackHeaderProps> = props => {
  const headerBackgroundContainerStyle = props.options?.headerBackgroundContainerStyle as ViewStyle
  return (
    <Box
      accessibilityRole="header"
      width="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor={
        headerBackgroundContainerStyle ? (headerBackgroundContainerStyle.backgroundColor as string) : 'white'
      }
      opacity={0.9}
    >
      <Box maxWidth="600px" width="full" minHeight="48px" display="flex" justifyContent="center">
        <RNHeader {...props} />
      </Box>
    </Box>
  )
}

export default Header
